import styles from './CreationSelection.module.less';
import coverDisco from '../../assets/images/cover_disco.png';
import coverCarta from '../../assets/images/cover_carta.png';
import coverLibro from '../../assets/images/cover_libro.png';
import coverExLibris from '../../assets/images/cover_ex_libris.png';

import CreateSelectionButton from '../UI/CreateSelectionButton';
import CreationSelectionGallery from "./CreationSelectionGallery";

function CreationSelection() {
  return (
    <div className={`${styles['creation-selection']} ${styles['creation-selection--bg-texture']}`}>
      <div className={`lg:flex hidden w-full h-full items-center justify-center gap-x-2 lg:px-5 xl:px-0`}>
        <div
          className={`xl:w-1/5 lg:w-1/4 flex justify-center ${styles['creation-selection__caratula']} h-12 flex-wrap`}
        >

          <div className={`${styles['creation-selection__number']} w-full`}>
            01
          </div>

          <div className="w-full flex justify-center items-center h-1/4">
            <img
              className={`${styles['creation-selection__caratula-disco']}`}
              src={coverDisco}
              alt=""
            />
          </div>

          <div className={`${styles['creation-selection__title']} w-full`}>
            Carátula <br /> de disco
          </div>
          <div className={`${styles['creation-selection__description']} w-full`}>
            Personaliza tu disco. <br/>
            ¡Pon a sonar tu <br/>
            imaginación!
          </div>
          <div className={`${styles['creation-selection__btn']} flex items-center`}>
            <CreateSelectionButton linkTo="/caratula-disco" />
          </div>
        </div>
        <div
          className={`xl:w-1/5 lg:w-1/4 flex justify-center ${styles['creation-selection__caratula']} h-12 flex-wrap`}
        >
          <div className={`${styles['creation-selection__number']} w-full`}>
            02
          </div>

          <div className="w-full flex justify-center items-center h-1/4">
            <img
              className={`${styles['creation-selection__caratula-disco']}`}
              src={coverLibro}
              alt=""
            />
          </div>

          <div className={`${styles['creation-selection__title']} w-full`}>
            Portada <br /> de libro
          </div>
          <div className={`${styles['creation-selection__description']} w-full`}>
            Crea la portada de un <br/>
            libro nuevo con <br/>
            fragmentos de libros <br/>
            viejos. Eso sí, a tu gusto.
          </div>
          <div className={`${styles['creation-selection__btn']} flex items-center`}>
            <CreateSelectionButton linkTo="/portada-libro" />
          </div>
        </div>
        <div
          className={`xl:w-1/5 lg:w-1/4 flex justify-center ${styles['creation-selection__caratula']} h-12 flex-wrap`}
        >
          <div className={`${styles['creation-selection__number']} w-full`}>
            03
          </div>
          <div className="w-full flex justify-center items-center h-1/4">
            <img
              className={`${styles['creation-selection__caratula-disco']}`}
              src={coverCarta}
              alt=""
            />
          </div>

          <div className={`${styles['creation-selection__title']} w-full`}>
            Carta <br /> &nbsp;
          </div>

          <div className={`${styles['creation-selection__description']} w-full`}>
            Escribe una carta <br/>
            que mezcle tus <br/>
            palabras con las de <br/>
            los personajes del <br/>
            archivo.
          </div>

          <div className={`${styles['creation-selection__btn']} flex items-center`}>
            <CreateSelectionButton linkTo="/carta" />
          </div>
        </div>
        <div
          className={`xl:w-1/5 lg:w-1/4 flex justify-center ${styles['creation-selection__caratula']} h-12 flex-wrap`}
        >
          <div className={`${styles['creation-selection__number']} w-full`}>
            04
          </div>

          <div className="w-full flex justify-center items-center h-1/4">
            <img
              className={`${styles['creation-selection__caratula-disco']}`}
              src={coverExLibris}
              alt=""
            />
          </div>

          <div className={`${styles['creation-selection__title']} w-full`}>
            Ex <br /> Libris
          </div>

          <div className={`${styles['creation-selection__description']} w-full`}>
            Crea un sello para <br/>
            marcar tus libros. <br/>
            ¡No volveras a perder<br/>
            ninguno!
          </div>
          <div className={`${styles['creation-selection__btn']} flex items-center`}>
            <CreateSelectionButton linkTo="/ex-libris" />
          </div>
        </div>
      </div>

      <CreationSelectionGallery />
    </div>
  );
}

export default CreationSelection;
